const TrendUp = ({ className }: { className: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='20'
    height='12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m14 0 2.29 2.29-4.88 4.88-4-4L0 10.59 1.41 12l6-6 4 4 6.3-6.29L20 6V0h-6Z'
      fill='currentColor'
    />
  </svg>
);

export default TrendUp;
